import { ServiceCodes } from './enums/service-codes';

export class ServiceSubscription {
    public id: number = null;
    public organizationId: string = null;
    public serviceCode: ServiceCodes = null;
    public updateDate: Date = null;
    public enabled: boolean = null;

    get editableId(): string | number {
        return this['id'];
    }

    public static createInstanceFromJson(other: any): ServiceSubscription {
        let instance = new ServiceSubscription();
        instance.id = other.id;
        instance.organizationId = other.organizationId;
        instance.serviceCode = other.serviceCode;
        instance.updateDate = other.updateDate;
        instance.enabled = other.enabled;
        return instance;
    }

    /**
     * Crée une copie profonde (deep copy) d'un tableau de ServiceSubscription.
     * @param other : Tableau d'instances de ServiceSubscription.
     * @returns : Une copie de tableau d'instances de ServiceSubscription.
     */
    public static createDeepCopyOfArray(others: ServiceSubscription[]) {
        if (!!others) {
            let deepCopy: ServiceSubscription[] = [];

            others.forEach((x) => {
                const action = ServiceSubscription.createDeepCopy(x);
                deepCopy.push(action);
            });

            return deepCopy;
        } else {
            return [];
        }
    }

    /**
     * Crée une copie profonde (deep copy) d'une instance de ServiceSubscription.
     * @param other : Instance de ServiceSubscription.
     * @returns : Une copie de l'instance de ServiceSubscription.
     */
    public static createDeepCopy(other: ServiceSubscription) {
        let instance = new ServiceSubscription();
        instance.id = other.id;
        instance.organizationId = other.organizationId;
        instance.serviceCode = other.serviceCode;
        instance.updateDate = other.updateDate;
        instance.enabled = other.enabled;
        return instance;
    }
}
